//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoMonthPickerBasic from './demos/DemoMonthPickerBasic.vue'
import DemoMonthPickerAllowedMonths from './demos/DemoMonthPickerAllowedMonths.vue'
import DemoMonthPickerIcons from './demos/DemoMonthPickerIcons.vue'
import DemoMonthPickerMultiple from './demos/DemoMonthPickerMultiple.vue'
import DemoMonthPickerReadonlyAndDisabled from './demos/DemoMonthPickerReadonlyAndDisabled.vue'
import DemoMonthPickerWidth from './demos/DemoMonthPickerWidth.vue'
import DemoMonthPickerDialogAndMenu from './demos/DemoMonthPickerDialogAndMenu.vue'
import DemoMonthPickerInternationalization from './demos/DemoMonthPickerInternationalization.vue'

// code
import {
  monthPickerBasic,
  monthPickerAllowedMonths,
  monthPickerIcons,
  monthPickerMultiple,
  monthPickerReadonlyAndDisabled,
  monthPickerWidth,
  monthPickerDialogAndMenu,
  monthPickerInternationalization,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoMonthPickerBasic,
    DemoMonthPickerAllowedMonths,
    DemoMonthPickerIcons,
    DemoMonthPickerMultiple,
    DemoMonthPickerReadonlyAndDisabled,
    DemoMonthPickerWidth,
    DemoMonthPickerDialogAndMenu,
    DemoMonthPickerInternationalization,
  },
  setup() {
    return {
      codeSnippets: {
        monthPickerBasic,
        monthPickerAllowedMonths,
        monthPickerIcons,
        monthPickerMultiple,
        monthPickerReadonlyAndDisabled,
        monthPickerWidth,
        monthPickerDialogAndMenu,
        monthPickerInternationalization,
      },
    }
  },
}
